export interface IdefaultAddSiteLeadFormInitialValues {
	siteName: string | null;
	siteArea: string | null;
	siteSpecialist: string | null;
	superVisorName?: string;
	superVisorNumber: string | null;
	siteLocation: string | null;
	contractorNumber: string | null;
	contractorName: string | null;
}

export const defaultAddMicroSiteLeadFormInitialValues: IdefaultAddSiteLeadFormInitialValues = {
	siteName: '',
	siteArea: '',
	siteSpecialist: '',
	superVisorName: '',
	superVisorNumber: '',
	siteLocation: '',
	contractorNumber: '',
	contractorName: '',
};

export interface MicroSite {
	siteName: string;
	siteArea: string;
	siteSpecialist: string;
	superVisorName: string;
	superVisorNumber: string;
	siteLocation: string;
	contractorNumber: string;
	contractorName: string;
	id: string;
}

export interface MicroSiteFormProps {
	data: MicroSite;
	index: number;
}
